import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';

import { AppComponent } from './app.component';
import { RouterOutlet } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { LoginLayoutComponent } from "./layouts/login/login-layout.component";
import { MainLayoutComponent } from "./layouts/main/main-layout.component";
import { ConfirmationComponent, LoaderComponent, TextComponent } from "ui-kit";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { TOASTER_CONFIG } from './app-config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { MobileLayoutComponent } from './layouts/mobile/mobile-layout.component';
import { MainMenuModule } from './modules/main-menu/desktop/main-menu.module';
import { MobileModule } from './modules/mobile/mobile.module';
import {provideNgxMask} from 'ngx-mask';
import { DecoratorOverlayService } from './core/utils/loader-decorator';
import { FormatDateForApiInterceptor } from './core/interceptors/format-date-for-api.interceptor';
import { ApplicationInsightsInterceptor } from './core/interceptors/application-insights.interceptor';
import { TenantDisabledInterceptor } from './core/interceptors/tenant-disabled.interceptor';
import { GlobalErrorHandler } from './core/error-handlers/global-error-handler';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [
    AppComponent,
    LoginLayoutComponent,
    MainLayoutComponent,
    MobileLayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterOutlet,
    TextComponent,
    ToastrModule.forRoot(TOASTER_CONFIG),
    ConfirmationComponent,
    LoaderComponent,
    MainMenuModule,
    MobileModule,
    MatIconModule,
    ScrollingModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FormatDateForApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApplicationInsightsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TenantDisabledInterceptor,
      multi: true
    },
    provideNgxMask(),
    DecoratorOverlayService,
    {
      provide: MAT_SELECT_SCROLL_STRATEGY,
      useFactory: (sso: ScrollStrategyOptions) => () => sso.close(),
      deps: [ScrollStrategyOptions],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
